function autoCheckPermission() {
  // 當勾選 show 的時候，自動勾選 index
  $('input[id$="_show"]').on('change', function() {
    if ($(this).is(':checked')) {
        // 找到同一個 permissions 區塊內的 index (列表) checkbox 並勾選
        $(this).closest('.permisssions')
               .find('input[id$="_index"]')
               .prop('checked', true);
    }
  });

  // 當勾選 new, create, edit, update, destroy 的時候，自動勾選 show 與 index
  const permissionTypes = ['new', 'create', 'edit', 'update', 'destroy'];
  const selector = permissionTypes.map(type => `input[id$="_${type}"]`).join(', ');

  $(selector).on('change', function() {
    if ($(this).is(':checked')) {
      // 找到同一個 permissions 區塊內的 show 與 index checkbox 並勾選
      $(this).closest('.permisssions')
             .find('input[id$="_show"], input[id$="_index"]')
             .prop('checked', true);
    }
  });

  // 全選 checkbox
  const $selectAllCheckboxes = $('.select-all');
  $selectAllCheckboxes.each(function(index, el_all) {
    // 同一個 permissions 區塊內 checkboxes
    let $selects = $(el_all).parents('.card').find('.permisssions').find('[type="checkbox"]');
    // 初始化
    let checkedCount = $selects.filter(':checked').length;
    if (checkedCount === $selects.length) {
      $(el_all).prop('checked', true);
    }
    // 全選功能
    $(el_all).on('click', function() {
      let isAll = $(this).is(':checked') ? true : false;
      $selects.each(function(index, el_select) {
        $(el_select).prop('checked', isAll);
      });
    });
    // 同一個 permissions 區塊內 checkboxes
    $selects.on('change', function() {
      let checkedCount = $selects.filter(':checked').length;
      let isAll = checkedCount === $selects.length;
      $(el_all).prop('checked', isAll);
    })
  });
}

document.addEventListener('DOMContentLoaded', function() {
  autoCheckPermission();
});
